// src/components/pages/Movimento/profiles/base/defaults.js
export const baseDefaults = {
    layout: null,
    natureza: null, // "Entrada" | "Saida" | "Ambos" etc (vamos usar depois)
    filtroProduto: true, //faz a consulta conforme os parametros em operações
    contabil: false, //para operações contabeis com impostos
    tabs: {
        cabecalho: { enabled: true },
        balanco: { enabled: false },
        financeiro: { enabled: true },
        imovel: { enabled: false },
        itens: { enabled: true },
        lancamento: { enabled: true },
        observacao: { enabled: true },
        frete: { enabled: false },
        aditivo: { enabled: false },
        assinatura: { enabled: true },
    },
    uiTabs: {
        cabecalho: {
            labels: {
                labColaborador: 'Colaborador',
                labParceiro: 'Parceiro',
                labParceiroVinculado: 'Parceiro Vinculado',
                labAdministrador: 'Administrador',
            },
            disabled: {
                centroCustoId: false,
                Colaborador: false,
            },
            readonly: {
                parceiro: false,
                cep: false,
                Logradouro: false,
                numero: false,
                bairro: false,
                complemento: false,
                uf: false,
                municipio: false,
            },
            show: {
                chNFe: false,
                empresa: true,
                datasBasicas: true,
                serie: false,
                situacao: true,

                administrador: false,
                parceiro: true,
                parceiroVinculado: false,
                colaborador: true,

                financeiroCabecalho: false,
                centroCusto: true,
                conta: false,
                forma: false,
                prazo: false,
                provisao: false,

                comissao: false,

                endereco: true,
                almoxarifado: true,
                dataPrevista: true,
                pedidoPadrao: false,
            },
        },
        financeiro: {},
        itens: {
            labels: {
                labColaborador: 'Colaborador',
                labParceiro: 'Parceiro',
                labParceiroVinculado: 'Parceiro Vinculado',
                labAdministrador: 'Administrador',
            },
            show: {
                permiteItemDuplicado: false,
                almoxarifado: true,
                disponivel: false,
                //financeiro
                precoNegociado: false,
                precoPorUnidade: false,
                valorUnitario: true,

                descontoPercentual: true,
                descontoValor: true,
                valorTotal: true,
                totalValor: true,
                //industria SEPARACAO
                conferenciaCodigo: false,
                refugo: false,
                parceiroItem: false,
                colaboradorItem: false,
                //industria PRODUCAO
                producaoMinima: false,
                sugestao: false,
                tabelaPreco: true,
                //nfe
                cfop: false,
                icms: false,
                ipi: false,
                pis: false,
                cofins: false,
            },
            usaTabelaPreco: false,
            digitaDatalistProduto: false, //consulta o produto por digitação no datalist
            datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
            quantidadePadrao: 0,
            valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
        },
        lancamento: {},
        observacao: {
            obsEntrada: false,
            obsLancamento: true,
            obsMovimento: true,
            obsRequisicao: false,
            obsSaida: false,
            obsServico: false,
        },
        frete: {},
        aditivo: {},
        assinatura: {},
    },
    function: {
        atualizaDadosParceiro: true, //ao mudar dados.parceiroId atualizar os dados, uzado em parceiroPadrao
    },
    parametros: {
        cabecalho: {
            parceiroVinculado: {
                fiador: false, //filtra os parceiros vinculados que são fiadores
                locatario: false, //filtra os parceiros vinculados que são locatarios
                locador: false, //filtra os parceiros vinculados que são locadores
            },
        },
        financeiro: {},
        itens: {
            geraFinanceiro: true,
            usaTabelaPreco: false,
            digitaDatalistProduto: false, //consulta o produto por digitação no datalist
            datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
            quantidadePadrao: 0,
            valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
        },
        lancamento: {},
        observacao: {
            obsEntrada: false,
            obsLancamento: false,
            obsMovimento: true,
            obsRequisicao: false,
            obsSaida: false,
            obsServico: false,
        },
        frete: {},
        aditivo: {},
        assinatura: {},

        //defaults para o sistema e não apenas para abas
        obrigaAlmoxarifado: true,
        parceiroPadrao: false, //movimento obtem o parceiro de parametro.pessoaId
        financeiroPadrao: false, //quando true => operacaoParametros injeta formaId, prazoId, contaId, centroCustoId por padrão false => ao selecionar o parceiroId faz a busca
        //parceiroIdGeraCustoFilial: false, //quando a empresa banca a despesa e no caso da fililal gera um pagamento para a empresa do colaborador
    },
};
